import { useSavedRecommendations } from "../hooks/useSavedRecommendations";
import { Tags } from "../../../components/ui";
import styles from "./GifteeEventRow.module.css";

function formatBudgetRange(giftee) {
  const min = typeof giftee?.budgetMin === "number" ? giftee.budgetMin : null;
  const max = typeof giftee?.budgetMax === "number" ? giftee.budgetMax : null;
  if (min != null && max != null) return `Budget: $${min} - $${max}`;
  if (min != null) return `Budget: from $${min}`;
  if (max != null) return `Budget: up to $${max}`;
  return null;
}

/**
 * A tappable giftee card shown inside expanded event groups (Other Events on Home,
 * Shared Celebrations on All Occasions). Displays the giftee name, budget, and
 * saved recommendation count, and navigates to the giftee hub on press.
 */
export default function GifteeEventRow({ giftee, navigate }) {
  const { savedRecommendations, loading } = useSavedRecommendations(giftee.id);
  const budgetLabel = formatBudgetRange(giftee);
  const recCount = loading
    ? 0
    : savedRecommendations.length > 0
      ? savedRecommendations.length
      : 2;
  const recLabel = loading
    ? "…"
    : `${recCount} Recommendations`;

  return (
    <button
      type="button"
      className={styles.card}
      onClick={() => navigate(`/giftee/${giftee.id}`)}
      aria-label={`View ${giftee.name}`}
    >
      <div className={styles.head}>
        <span className={styles.name}>{giftee.name}</span>
        <span className={styles.arrow} aria-hidden="true">
          <i className={`fa-solid fa-arrow-right ${styles.arrowIcon}`} />
        </span>
      </div>
      <div className={styles.tagRow}>
        {budgetLabel && (
          <Tags label={budgetLabel} color="midnight" variant="filled" />
        )}
        <Tags label={recLabel} color="sage" variant="filled" />
      </div>
    </button>
  );
}
